"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tokenizer = void 0;
var constant_1 = require("../constant");
var general_format_utils_1 = require("../general/general-format-utils");
var date_format_utils_1 = require("../date/date-format-utils");
// 暂时从原始函数中引用, 待合入后更新
var FormatUtils_1 = require("../../utils/FormatUtils");
var Common_1 = require("../../utils/Common");
var Tokenizer = /** @class */ (function () {
    function Tokenizer(format, value, formatListLength, options) {
        this.isValid = true;
        this.lastParsedType = constant_1.TokenType.Text;
        this.isNeedToBreak = false;
        this.index = 0;
        // 结果变量
        this.formatDate = null;
        this.tokenizedList = [];
        this.hourSystemType = constant_1.TokenType.FullDayHours;
        this.format = format;
        this.value = value;
        this.formatListLength = formatListLength;
        this.options = options;
    }
    /**
     * 对格式串进行扫描分词
     */
    // eslint-disable-next-line complexity
    Tokenizer.prototype.run = function () {
        while (this.index < this.format.length && this.isValid) {
            this.currentChar = this.format.charAt(this.index);
            switch (this.currentChar) {
                case 'G':
                    this.handleGeneral();
                    break;
                case '"':
                    this.handleQuotation();
                    break;
                case '\\':
                    this.handleBackSlash();
                    break;
                case '_':
                    this.handleUnderline();
                    break;
                case '@':
                    this.handleAt();
                    break;
                case 'B':
                case 'b':
                    this.handleBOrb();
                    // 判断内部是否需要 break
                    if (this.isNeedToBreak) {
                        this.isNeedToBreak = false;
                        break;
                    }
                case 'M':
                case 'D':
                case 'Y':
                case 'H':
                case 'S':
                case 'E':
                    this.handleUpperCaseTimeRelated();
                case 'm':
                case 'd':
                case 'y':
                case 'h':
                case 's':
                case 'e':
                case 'g':
                    this.handleLowerCaseTimeRelated();
                    break;
                case 'A':
                case 'a':
                    this.handleAOra();
                    break;
                case '上':
                    this.handleChineseDayTime();
                    break;
                case '[':
                    this.handleLeftBracket();
                    break;
                case '.':
                    this.handleDot();
                    // 判断内部是否需要 break
                    if (this.isNeedToBreak) {
                        this.isNeedToBreak = false;
                        break;
                    }
                case '0':
                case '#':
                    this.handleZeroOrPound();
                    break;
                case '?':
                    this.handleQuestionMark();
                    break;
                case '*':
                    this.handleAsterisk();
                    break;
                case '(':
                case ')':
                    this.handleParentheses();
                    break;
                case '1':
                case '2':
                case '3':
                case '4':
                case '5':
                case '6':
                case '7':
                case '8':
                case '9':
                    this.handleNumber();
                    break;
                case ' ':
                    this.handleSpace();
                    break;
                case '%':
                    this.handlePercent();
                    break;
                default:
                    this.handleOthers();
                    break;
            }
        }
    };
    Tokenizer.prototype.getTokenizedResult = function () {
        return {
            formatDate: this.formatDate,
            hourSystemType: this.hourSystemType,
            tokenizedList: this.tokenizedList,
        };
    };
    /**
     * 向分词结果数组中添加分词
     * @param type 分词类型
     * @param value 分词值
     */
    Tokenizer.prototype.addNewToken = function (type, value) {
        this.tokenizedList.push({ type: type, value: value });
    };
    /**
     * 根据输入值计算对应时间日期对象, 返回是否解析成功
     * @param isSpecialStartTime 是否以特殊时间为参考点
     */
    Tokenizer.prototype.updateFormatDate = function (isSpecialStartTime) {
        if (this.formatDate === null) {
            this.formatDate = date_format_utils_1.parse_date_code(Number(this.value), this.options, isSpecialStartTime);
            // 若解析失败, 设置该次解析失败
            if (this.formatDate === null) {
                this.isValid = false;
                this.isNeedToBreak = true;
                return false;
            }
        }
        return true;
    };
    /**
     * 分词函数处理 ‘G', 代表常规模式
     */
    Tokenizer.prototype.handleGeneral = function () {
        if (!general_format_utils_1.isGeneral(this.format, this.index)) {
            throw new Error("unrecognized character " + this.currentChar + " in " + this.format);
        }
        this.addNewToken(constant_1.TokenType.General, 'General');
        this.index += 7;
    };
    /**
     * 分词函数处理 '"", 代表后续可能为文本
     */
    Tokenizer.prototype.handleQuotation = function () {
        this.index += 1;
        // 截取文本内字符串
        for (this.tempString = ''; this.index < this.format.length; this.index++) {
            this.tempChar = this.format.charAt(this.index);
            if (this.tempChar === '"') {
                break;
            }
            this.tempString += this.tempChar;
        }
        // 分词成功并将当前下标前移
        this.addNewToken(constant_1.TokenType.Text, this.tempString);
        this.index += 1;
    };
    /**
     * 分词函数处理 '\\", 代表不同格式间的分隔符, 例如颜色与负数格式 ‘[Red]\\(#,##0.00\\)’
     */
    Tokenizer.prototype.handleBackSlash = function () {
        this.index += 1;
        // 判断下一个字符是否是括号
        this.tempChar = this.format.charAt(this.index);
        if (this.tempChar === '(' || this.tempChar === ')') {
            this.addNewToken(this.tempChar, this.tempChar);
        }
        else {
            this.addNewToken(constant_1.TokenType.Text, this.tempChar);
        }
        this.index += 1;
    };
    /**
     * 分词处理 '_', 代表空与后面一位字符宽度相同的空格, 目前只空普通空格, 与 excel 不一致
     */
    Tokenizer.prototype.handleUnderline = function () {
        this.addNewToken(constant_1.TokenType.Text, ' ');
        this.index += 2;
    };
    /**
     * 分词处理 '@', 代表文本格式
     */
    Tokenizer.prototype.handleAt = function () {
        this.addNewToken(constant_1.TokenType.TextPlaceholder, String(this.value));
        this.index += 1;
    };
    /**
     * 分词处理 'B, b', 代表特殊起始参考日期
     */
    Tokenizer.prototype.handleBOrb = function () {
        if (this.format.charAt(this.index + 1) === '1' || this.format.charAt(this.index + 1) === '2') {
            var isformatDateValid = this.updateFormatDate(this.format.charAt(this.index + 1) === '2');
            // 日期解析值不合理直接返回
            if (!isformatDateValid) {
                return;
            }
            this.addNewToken(constant_1.TokenType.SpecialStartGenesis, this.format.substr(this.index, 2));
            this.lastParsedType = constant_1.TokenType.BuddhistYear;
            this.index += 2;
            this.isNeedToBreak = true;
        }
    };
    /**
     * 分词处理 ‘M, D, Y, H, S, E', 代表大写格式串与时间、日期相关
     */
    Tokenizer.prototype.handleUpperCaseTimeRelated = function () {
        this.currentChar = this.currentChar.toLowerCase();
    };
    /**
     * 分词处理 ‘M, D, Y, H, S, E', 代表大写格式串与时间、日期相关
     */
    // eslint-disable-next-line complexity
    Tokenizer.prototype.handleLowerCaseTimeRelated = function () {
        // 时间值不为数值类型或者为负数, 直接返回
        if (!Common_1.isNumeric(this.value) || Number(this.value) < 0) {
            this.isValid = false;
            return;
        }
        // 判断解析的时间是否合理, 不合理直接返回
        var isformatDateValid = this.updateFormatDate();
        if (!isformatDateValid) {
            return;
        }
        this.tempString = this.currentChar;
        // 如果接下来的字符与当前相同, 一直截取下去
        this.index += 1;
        while (this.index < this.format.length
            && this.format.charAt(this.index).toLowerCase() === this.currentChar) {
            this.tempString += this.currentChar;
            this.index += 1;
        }
        // m 连续小于两个且上一个解析到的类型是小时或者分钟则判断为分钟 (因为 m 不存在连续超过两个的格式串)
        if (this.currentChar === 'm'
            && (this.lastParsedType.toLowerCase() === 'h' || this.lastParsedType.toLowerCase() === 's')
            && this.tempString.length <= 2) {
            this.currentChar = 'M';
        }
        // 以当前小时制为为最终类型
        if (this.currentChar === 'h') {
            this.currentChar = this.hourSystemType;
        }
        this.addNewToken(this.currentChar, this.tempString);
        this.lastParsedType = this.currentChar;
    };
    /**
     * 分词处理 'A,a', 代表英文表达中的上午下午
     */
    Tokenizer.prototype.handleAOra = function () {
        this.tempToken = { type: this.currentChar, value: this.currentChar };
        // 判断解析的时间是否合理, 不合理直接返回
        var isformatDateValid = this.updateFormatDate();
        if (!isformatDateValid) {
            return;
        }
        // 根据后面跟随的字符判断是否为12小时制类型
        if (this.format.substr(this.index, 3).toUpperCase() === 'A/P') {
            this.tempToken.value = this.formatDate && this.formatDate.hour >= 12 ? 'P' : 'A';
            this.tempToken.type = constant_1.TokenType.TextPlaceholder;
            this.hourSystemType = constant_1.TokenType.HalfDayHours;
            this.index += 3;
        }
        else if (this.format.substr(this.index, 5).toUpperCase() === 'AM/PM') {
            this.tempToken.value = this.formatDate && this.formatDate.hour >= 12 ? 'PM' : 'AM';
            this.tempToken.type = constant_1.TokenType.TextPlaceholder;
            this.hourSystemType = constant_1.TokenType.HalfDayHours;
            this.index += 5;
        }
        else if (this.format.substr(this.index, 4) === 'aaaa') {
            this.tempToken.type = constant_1.TokenType.Week;
            this.tempToken.value = 'aaaa';
            this.index += 4;
        }
        else if (this.format.substr(this.index, 3) === 'aaa') {
            this.tempToken.type = constant_1.TokenType.Week;
            this.tempToken.value = 'aaa';
            this.index += 3;
        }
        else {
            this.tempToken.type = constant_1.TokenType.Text;
            this.index += 1;
        }
        this.addNewToken(this.tempToken.type, this.tempToken.value);
        this.lastParsedType = this.tempToken.type;
    };
    /**
     * 分词处理 '上', 代表中文时间上的上午下午
     */
    Tokenizer.prototype.handleChineseDayTime = function () {
        this.tempToken = { type: this.currentChar, value: this.currentChar };
        // 判断解析的时间是否合理, 不合理直接返回
        var isformatDateValid = this.updateFormatDate();
        if (!isformatDateValid) {
            return;
        }
        // 判断接下来5个格式串是否是 '上午/下午'
        if (this.format.substr(this.index, 5).toUpperCase() === '上午/下午') {
            this.tempToken.value = this.formatDate && this.formatDate.hour >= 12 ? '下午' : '上午';
            this.tempToken.type = constant_1.TokenType.TextPlaceholder;
            this.index += 5;
            this.hourSystemType = constant_1.TokenType.HalfDayHours;
        }
        else {
            this.tempToken.type = constant_1.TokenType.Text;
            this.index += 1;
        }
        this.addNewToken(this.tempToken.type, this.tempToken.value);
        this.lastParsedType = this.tempToken.type;
    };
    /**
     * 分词处理 '[', 处理中括号内的内容包括日期、国家、颜色等
     */
    // eslint-disable-next-line complexity
    Tokenizer.prototype.handleLeftBracket = function () {
        this.tempString = this.currentChar;
        // 截取 [] 内容
        while (this.format.charAt(this.index) !== ']' && this.index + 1 < this.format.length) {
            this.index += 1;
            this.tempString += this.format.charAt(this.index);
        }
        this.index += 1;
        // 若无 ] 作结尾直接抛出异常
        if (this.tempString.slice(-1) !== ']') {
            throw "unterminated \"[\" block: |" + this.tempString + "|";
        }
        // [] 内容为时间
        if (this.tempString.match(/\[[HhMmSs]*\]/)) {
            // 判断日期是否有效
            var isformatDateValid = this.updateFormatDate();
            if (!isformatDateValid) {
                return;
            }
            this.addNewToken(constant_1.TokenType.AbsoluteTime, this.tempString.toLowerCase());
            this.lastParsedType = this.tempString.charAt(1);
        }
        else if (this.tempString.toLowerCase() === '[$-f800]') {
            // 处理[$-F800]
            this.format = this.format.substr(0, this.index) + "yyyy\"\u5E74\"m\"\u6708\"d\"\u65E5\" aaaa";
            return;
        }
        else if (this.tempString.toLowerCase() === '[$-f400]') {
            // 处理[$-F400], 对齐windows excel体验
            this.format = this.format.substr(0, this.index) + "\u4E0A\u5348/\u4E0B\u5348 h:mm:ss";
            return;
        }
        else if (this.tempString.indexOf('$') > -1) {
            this.tempString = (this.tempString.match(/\$([^-[\]]*)/) || [])[1] || '$';
            if (/\[\$-\d+\].*a{3,4}/.test(this.format)) {
                // 日期类型 星期x或者周x  暂时不支持国家，这个就忽略掉
                return;
            }
            if (!date_format_utils_1.fmtIsDate(this.format)) {
                this.addNewToken(constant_1.TokenType.Text, this.tempString);
            }
        }
        else if (this.tempString.match(/DBNum\d+/)) {
            this.addNewToken(constant_1.TokenType.ChineseNumber, this.tempString);
            this.tempString = '';
            // 忽略后面的国家相关串, 例如 [DBNum2][$-804] 表示中文大写格式
            if (this.index < this.format.length && this.format.charAt(this.index) === '[') {
                while (this.format.charAt(this.index) !== ']' && this.index + 1 < this.format.length) {
                    this.index += 1;
                    this.tempString += this.format.charAt(this.index);
                }
                this.index += 1;
                if (this.tempString.slice(-1) !== ']') {
                    throw "unterminated \"[\" block: |" + this.tempString + "|";
                }
            }
        }
        else if (FormatUtils_1.isColorFormat(this.tempString)) {
            this.addNewToken(constant_1.TokenType.Color, FormatUtils_1.getColorByFormat(this.tempString));
        }
    };
    /**
     * 分词处理 '.', 代表小数点位或者秒一下的时间的小数点
     */
    Tokenizer.prototype.handleDot = function () {
        // 针对类似 mm:ss.0 的时间类格式串
        if (this.formatDate !== null) {
            this.tempString = this.currentChar;
            this.index += 1;
            while (this.index < this.format.length) {
                this.currentChar = this.format.charAt(this.index);
                if (this.currentChar !== '0') {
                    break;
                }
                this.tempString += this.currentChar;
                this.index += 1;
            }
            this.addNewToken(constant_1.TokenType.Second, this.tempString);
            this.isNeedToBreak = true;
        }
    };
    /**
     * 分词处理 '0,#', 代表与数值相关的格式
     */
    Tokenizer.prototype.handleZeroOrPound = function () {
        var _this = this;
        this.tempString = this.currentChar;
        this.index += 1;
        while (this.index < this.format.length) {
            this.currentChar = this.format.charAt(this.index);
            // eslint-disable-next-line no-loop-func
            var getCountinueCondition1 = function () { return '0#?.,E+-%'.indexOf(_this.currentChar) > -1; };
            // eslint-disable-next-line no-loop-func
            var getCountinueCondition2 = function () { return /^\\-[0#]$/.test(_this.format.substr(_this.index, 3)); };
            // 如果下一位是 '0#?.,E+-%' 中任意一个或者之后连续的三位为 '\-0' 或 '\-#', 均选择截取
            if (getCountinueCondition1() || getCountinueCondition2()) {
                this.tempString += this.currentChar;
                this.index += 1;
            }
            else {
                break;
            }
        }
        this.addNewToken(constant_1.TokenType.Number, this.tempString);
    };
    /**
     * 分词处理 '?', 代表占位符
     */
    Tokenizer.prototype.handleQuestionMark = function () {
        this.tempString = this.currentChar;
        this.index += 1;
        // 截取之后连续的占位符
        while (this.format.charAt(this.index) === this.currentChar) {
            this.tempString += this.currentChar;
            this.index += 1;
        }
        this.addNewToken(constant_1.TokenType.QuestionMark, this.tempString);
        this.lastParsedType = constant_1.TokenType.QuestionMark;
    };
    /**
     * 分词处理 '*', 代表用跟随的字符串补齐空白，暂不处理
     */
    Tokenizer.prototype.handleAsterisk = function () {
        this.index += 2;
    };
    /**
     * 分词处理 '(,)', 代表文本或表示负数显示时的括号
     */
    Tokenizer.prototype.handleParentheses = function () {
        var tokenType = this.formatListLength === 1 ? constant_1.TokenType.Text : this.currentChar;
        this.addNewToken(tokenType, this.currentChar);
        this.index += 1;
    };
    /**
     * 分词处理 '1-9', 代表数字
     */
    Tokenizer.prototype.handleNumber = function () {
        this.tempString = this.currentChar;
        // 截取后面连续的数字
        while (this.index < this.format.length) {
            this.index += 1;
            this.currentChar = this.format.charAt(this.index);
            if ('0123456789'.indexOf(this.currentChar) === -1) {
                break;
            }
            this.tempString += this.format.charAt(this.index);
        }
        this.addNewToken(constant_1.TokenType.Digit, this.tempString);
    };
    /**
     * 分词处理 ' ', 代表空白
     */
    Tokenizer.prototype.handleSpace = function () {
        this.tempString = this.currentChar;
        // 判断后面是否均为空白
        while (this.index < this.format.length) {
            this.index += 1;
            this.currentChar = this.format.charAt(this.index);
            if (' ' !== this.currentChar) {
                break;
            }
            this.tempString += this.format.charAt(this.index);
        }
        this.addNewToken(constant_1.TokenType.Space, this.tempString);
    };
    /**
     * 分词处理 '%', 代表百分数
     */
    Tokenizer.prototype.handlePercent = function () {
        this.addNewToken(constant_1.TokenType.Number, this.currentChar);
        this.index += 1;
    };
    /**
     * 其余默认处理
     */
    Tokenizer.prototype.handleOthers = function () {
        // 若未出现以下格式字符
        // eslint-disable-next-line @typescript-eslint/quotes
        if (",$-+/():!^&'~{}<>=€acfijklopqrtuvwxzP".indexOf(this.currentChar) === -1) {
            this.isValid = false;
            return;
        }
        this.addNewToken(constant_1.TokenType.Text, this.currentChar);
        this.index += 1;
    };
    return Tokenizer;
}());
exports.Tokenizer = Tokenizer;
//# sourceMappingURL=tokenizer.js.map